import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { MatInputModule } from '@angular/material/input'
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { NgxMaskDirective } from 'ngx-mask'
import { ConsultantService } from '../../../../core/services/person/consultant/consultant.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import moment from 'moment/moment'
import { emailValidator } from '../../../../shared/utils/email_validator'
import { formatDateForm } from '../../../../shared/utils/utils'
import { ChangeDetectorRef } from '@angular/core'
import { JsonPipe } from '@angular/common'

@Component({
  selector: 'consultant-client-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    JsonPipe,
  ],
  templateUrl: './consultant-client-edit-form.component.html',
  styleUrl: './consultant-client-edit-form.component.scss',
  providers: [ConsultantService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsultantClientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private consultantService: ConsultantService,
    private snackbar: SnackbarCustomService,
    private cdr: ChangeDetectorRef,
  ) {
    const today = new Date() // Data atual
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
  }

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() idClient: number = 0
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined

  listType: any[] = []

  maxDate!: Date

  ngOnInit(): void {
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.resetForm()
      this.fillForm()
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.edit) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('name')?.setValue(this.editItem.data.nome)
    this.form.get('email')?.setValue(this.editItem.data.email)
    this.form.get('phone')?.setValue(this.editItem.data.telefone)
    this.form
      .get('birth')
      ?.setValue(
        this.editItem.data.dataNascimento &&
          this.editItem.data.dataNascimento != ''
          ? moment(this.editItem.data.dataNascimento, 'DD/MM/YYYY').toDate()
          : '',
      )
    this.cdr.detectChanges()
  }

  resetForm() {
    this.form.get('name')?.setValue('')
    this.form.get('phone')?.setValue('')
    this.form.get('email')?.setValue('')
    this.form.get('birth')?.setValue('')
    this.cdr.detectChanges()
    // this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      email: ['', [Validators.required, emailValidator()]],
      birth: [''],
    })
  }

  createConsultant() {
    this.loading = true
    const model = this.createModel()
    this.consultantService.createConsultant(model).subscribe({
      next: (response: any) => {
        if (response.statusCode == 200) {
          this.addConsultant(response.data.id, response.message)
        } else {
          this.snackbar.info(response.message)
          this.loading = false
          this.cdr.detectChanges()
        }
        // this.snackbar.success(response.message)
        // this.response.emit({ refresh: true, clear: true })
        // this.resetForm()
      },
      error: (err: ErrorRequestModel) => {
        let response: any = err.error
        if (response.statusCode == 409) {
          this.addConsultant(response.data.id, response.message)
        } else {
          this.loading = false
          this.cdr.detectChanges()
          this.snackbar.errorRequest(err)
        }
      },
      complete: () => {
        this.loading = false
        this.cdr.detectChanges()
      },
    })
  }

  addConsultant(
    idConsultant: number,
    message: string = 'Cadastrado com sucesso.',
  ) {
    const model = {
      consultorId: idConsultant,
      clienteId: this.idClient,
    }
    this.consultantService.addConsultantClient(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
        this.cdr.detectChanges()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
        this.cdr.detectChanges()
      },
      complete: () => {
        this.loading = false
        this.cdr.detectChanges()
      },
    })
  }

  editConsultant() {
    // this.loading = true
    const model = this.createModel(true)
    this.consultantService.editConsultant(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
        this.cdr.detectChanges()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
        this.cdr.detectChanges()
      },
      complete: () => {
        this.loading = false
        this.cdr.detectChanges()
      },
    })
  }

  cancel() {
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        id: this.editItem.data.consultorId,
        // clienteId: this.idClient,
        nome: this.form.controls['name'].value,
        email: this.form.controls['email'].value,
        telefone: this.form.controls['phone'].value,
        nascimento: formatDateForm(this.form.controls['birth'].value),
        // this.form.controls['birth'].value != ''
        //   ? moment(this.form.controls['birth'].value).format('DD/MM/YYYY')
        //   : '',
      }
    } else {
      return {
        // clienteId: this.idClient,
        nome: this.form.controls['name'].value,
        email: this.form.controls['email'].value,
        telefone: this.form.controls['phone'].value,
        nascimento: formatDateForm(this.form.controls['birth'].value),
        // nascimento:
        //   this.form.controls['birth'].value != ''
        //     ? moment(this.form.controls['birth'].value).format('DD/MM/YYYY')
        //     : '',
      }
    }
  }

  openDatepicker() {
    if (this.datepicker) {
      this.datepicker.open()
    }
  }
}
